import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import map from 'lodash/map';
import find from 'lodash/find';
import pick from 'lodash/pick';
import flatten from 'lodash/flatten';
import partialRight from 'lodash/partialRight';
import { Pagination, Empty } from 'antd';
import ListingCard, { ListingCardSkeleton } from '../Card';
import { track, preparePayload, prepareListingPayload } from '../../../helpers/searchResultsAnalytics';
import SortSelector from '../../SearchFilter/filters/SortSelector';
import OptimizeExperiment from '../../optimizeExperiment';
import { updateSearchFilters as update } from '../../../actions';
import { Breakpoint } from '../../../helpers/MediaQuery';
import { t } from '../../../helpers/t';
import TopSearchSuggestions from './searchSuggestions';
import ReassuranceBanner from './reassuranceBanner';

let firstSearch = true;

export default function ListingResults() {
  const dispatch = useDispatch();
  const nSkeleton = 36;

  const { mapVisible } = useSelector((state) => state.map);
  const { isLoading, listings, meta } = useSelector((state) => state.searchResults);
  const { parameters } = useSelector((state) => state.searchFilters);

  let cards = map(listings, (listing, i) => (
    [
      <OptimizeExperiment key={-listing.id} html={`<div class='oxp-${i}'></div>`} />,
      <ListingCard
        loadASAP={i < 6}
        key={listing.id}
        listing={listing}
        onMouseEnter={() => dispatch({ type: 'SET_MAP_HIGHLIGHTED_FEATURE', payload: listing.id })}
        onMouseLeave={() => dispatch({ type: 'SET_MAP_HIGHLIGHTED_FEATURE', payload: null })}
      />,
    ]
  ));
  cards = flatten(cards);

  const skeletons = [...new Array(nSkeleton)]
    .map((entry, index) => (<ListingCardSkeleton key={index} />));

  useEffect(() => {
    jQuery('html, body').animate({ scrollTop: 0 }, 200);

    if (listings) {
      jQuery(window).off('scroll.viewCards');
      jQuery(window).on('scroll.viewCards', () => {
        jQuery('.listing-card:not(.is-viewed)').each(function () {
          const card = jQuery(this)[0].getBoundingClientRect();
          const listing = find(listings, { id: jQuery(this).data('id') });

          if (
            card.top > 64
            && card.top < (window.innerHeight - (card.height / 2) - 37)
          ) {
            jQuery(this).addClass('is-viewed');
            track('Listing Search Card Viewed', prepareListingPayload(listing));
          }
        });
      });
    }
  }, [listings, isLoading]);

  function changePage(page) {
    if (jQuery) {
      jQuery('html, body').animate({ scrollTop: 0 }, 200);
    }

    dispatch({ type: 'SET_PAGE_SEARCH_RESULTS', payload: page });
  }

  useEffect(() => {
    // TODO: To be removed after Google Optimize Experiment
    window.searchData = map(listings, partialRight(pick, ['id', 'daily_price', 'weekly_price', 'monthly_price']));

    track(
      'Listings Search Results Viewed',
      preparePayload(parameters, meta.total, meta.pages, meta.page)
        .merge({ results_on_current_page: map(listings, 'id') })
        .value(),
    );
  }, [listings]);

  useEffect(() => {
    if (firstSearch) {
      firstSearch = false;
      return;
    }
    changePage(1);
  }, []);

  const updateSearchFilters = (filterParameter) => dispatch(update(filterParameter));

  return (
    <div id="search-results-container">
      <div className={mapVisible ? undefined : 'full-width'}>
        <Breakpoint lessThan="sortSelectorBreak">
          <SortSelector
            sortOrder={parameters.s}
            updateSearchFilters={updateSearchFilters}
          />
        </Breakpoint>
        {parameters.zoom >= 14 && meta.page === 1 && <TopSearchSuggestions city={parameters.city} />}
        {
        // eslint-disable-next-line no-nested-ternary
        isLoading
          ? skeletons
          : (
            (listings && !listings.length)
              ? <NoResults />
              : (
                <>
                  <ReassuranceBanner />
                  {cards}
                </>
              )
          )
      }
        <Pagination
          className="search-pagination"
          current={meta.page}
          pageSize={40}
          total={meta.total}
          onChange={changePage}
          disabled={isLoading}
          showSizeChanger={false}
          hideOnSinglePage
        />
      </div>
    </div>
  );
}

function NoResults() {
  const [formalooSrc, setFormalooSrc] = useState('');

  useEffect(() => {
    const formalooFormIds = {
      en: 'uwn22g',
      fr: 'yx2qxo',
      it: 'f4lyhc',
    };

    const lang = (window.env && window.env.user_language)
      ? window.env.user_language.split(/[-_]/)[0]
      : 'en';

    const formId = formalooFormIds[lang] || formalooFormIds.en;
    setFormalooSrc(`https://storefront.formaloo.me/${formId}`);
  }, []);

  return (
    <Empty
      className="listings-no-results"
      description={(
        <div>
          <p style={{ textAlign: 'center' }}>
            {t('directives.listingResults.noResult.p1')}
            {t('directives.listingResults.noResult.p2')}
          </p>
          <p style={{ textAlign: 'center' }}>{t('directives.listingResults.noResult.p3')}</p>
          <div className="formaloo-form-container">
            { formalooSrc && (
              <iframe
                title="Concierge Request Form"
                onLoad={() => {
                  try {
                    parent.scrollTo(0, 0);
                  } catch (e) {
                    // Silently fail on cross-origin access
                  }
                }}
                height="750"
                frameBorder="0"
                scrolling="yes"
                style={{ width: '100%', border: 'none' }}
                src={formalooSrc}
                id="formalooIframe"
              />
            )}
          </div>
        </div>
      )}
    />
  );
}
